import { EmployeeRole } from '@/types';
import { ErrorReporter } from '@/utils/sentry';
import { useEffect } from 'react';

interface SentrySessionTrackingParams {
  isOfflineModeActive: boolean;
  relationship:
    | {
        employeeRole: EmployeeRole | null;
        supplierUUID: string;
        uuid: string;
      }
    | null
    | undefined;
  supplierEmployeeRole: EmployeeRole | null | undefined;
}

export const useSentrySessionTracking = ({
  isOfflineModeActive,
  relationship,
  supplierEmployeeRole,
}: SentrySessionTrackingParams) => {
  const supplierUUID = relationship?.supplierUUID;
  const restaurantUUID = relationship?.uuid;
  const restaurantEmployeeRole = relationship?.employeeRole;

  useEffect(() => {
    ErrorReporter.setTag('supplier.uuid', supplierUUID);
    ErrorReporter.setTag('restaurant.uuid', restaurantUUID);
    ErrorReporter.setTag(
      'supplier.employee_role',
      supplierEmployeeRole ?? undefined,
    );
    ErrorReporter.setTag(
      'restaurant.employee_role',
      restaurantEmployeeRole ?? undefined,
    );

    return () => {
      ErrorReporter.setTag('supplier.uuid', undefined);
      ErrorReporter.setTag('restaurant.uuid', undefined);
      ErrorReporter.setTag('supplier.employee_role', undefined);
      ErrorReporter.setTag('restaurant.employee_role', undefined);
    };
  }, [
    supplierUUID,
    restaurantUUID,
    supplierEmployeeRole,
    restaurantEmployeeRole,
  ]);

  useEffect(() => {
    ErrorReporter.setTag('app.offline_mode', isOfflineModeActive);

    return () => {
      ErrorReporter.setTag('app.offline_mode', undefined);
    };
  }, [isOfflineModeActive]);
};
